import { Box, Button, Grid, Modal, Popover, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowHelperTextModal, SupportSheetHelpTextSelector } from './reducers/SupportSheetHelpTextReducer';
import { PopupEmail } from '../../SupportSheetPreVoyage';
import { SupportSheetSelector } from '../../reducers/SupportSheetReducer';

const SupportSheetHelpTextModal: React.FunctionComponent = (props) => {
    const dispatch = useDispatch();
    const helpTextData = useSelector(SupportSheetHelpTextSelector);
    const supportSheetData = useSelector(SupportSheetSelector);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "800px",
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return (
        <>
            <Modal
                open={helpTextData.showInput}
                onClose={() => {
                    if (helpTextData.showEmailAfterOk) {
                        PopupEmail(helpTextData.emailSendAfterAgree, supportSheetData.brokerEmails);
                    }
                    dispatch(setShowHelperTextModal(false));
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="server-modal-title" variant="h6" component="h2">
                        {helpTextData.title}
                    </Typography>
                    <Typography id="server-modal-description" sx={{ pt: 2 }}
                        dangerouslySetInnerHTML={{ __html: helpTextData.helperText }}
                    >
                    </Typography>
                    <div className='server-modal-confirm-button'>
                        <Button
                            variant='contained'
                            onClick={() => {
                                if (helpTextData.showEmailAfterOk) {
                                    PopupEmail(helpTextData.emailSendAfterAgree, supportSheetData.brokerEmails);
                                }
                                dispatch(setShowHelperTextModal(false));
                            }}
                        >Ok</Button>
                    </div>
                </Box>
            </Modal>
        </>
    )
};

export default SupportSheetHelpTextModal;